import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Globe, Youtube } from 'lucide-react';
import { Button } from '@/components/ui/button';
import DynamicTitle from '@/components/DynamicTitle';

export default function Bio() {
  return (
    <div className="min-h-screen flex flex-col bg-[#0a0a0a]">
      <DynamicTitle 
        title="About Aram AI - Armenian AI Solopreneur & Educator"
        description="Connect with Aram AI on social media. Follow his journey as an AI solopreneur sharing insights about artificial intelligence, entrepreneurship, and Armenian tech community."
        keywords="Aram AI social media, AI entrepreneur, Armenian AI community, Instagram, LinkedIn, YouTube, tech content creator"
        canonicalUrl="https://aramb.am/bio"
      />
      
      <div className="py-4">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img 
                src="/lovable-uploads/bfbf7207-f95c-4e56-94ae-89fe4b487cc9.png" 
                alt="Aram AI Logo" 
                className="h-8 w-auto" 
              />
            </Link>
            
            {/* <Button 
              asChild
              variant="outline" 
              className="gradient-border bg-black/60 border border-[#9b87f5] hover:bg-black/80 text-white"
            >
              <Link to="/donate" className="flex items-center gap-1">
                <div className="w-5 h-5 flex items-center justify-center animate-pulse">
                  <img 
                    src="/lovable-uploads/db0a8c1d-0735-4000-94e6-b2c38cd9e104.png" 
                    alt="Pixelated heart" 
                    className="w-full h-full object-contain"
                  />
                </div>
                Donate
              </Link>
            </Button> */}
          </div>
        </div>
      </div>
      
      <main className="flex-1 container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-8">
            <div className="flex items-center gap-6">
              <img
                src="/lovable-uploads/490eaf55-e3e9-4b08-a739-d7ffa6d8a3d9.png"
                alt="Aram AI Profile"
                className="w-24 h-24 rounded-full border-2 border-white/10"
              />
              <div>
                <h1 className="text-3xl font-bold text-white mb-2">Aram AI</h1>
                <p className="text-gray-400">AI solopreneur</p>
              </div>
            </div>

            <p className="text-gray-300 leading-relaxed">
              AI solopreneur, sharing valuable insights, strategies, and experiences on the journey to becoming a top AI solopreneur and building impactful AI businesses.
            </p>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-white mb-4">Connect With Me</h2>
              <div className="space-y-3">
                <a
                  href="https://www.instagram.com/iamaram.ai/"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
                  data-umami-event="instagram"
                >
                  <Instagram className="h-5 w-5 text-gray-400" />
                  <span className="text-gray-300">Follow on Instagram</span>
                </a>
                
                <a
                  href="https://www.linkedin.com/in/aramai"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
                  data-umami-event="linkedin"
                >
                  <Linkedin className="h-5 w-5 text-gray-400" />
                  <span className="text-gray-300">Connect on LinkedIn</span>
                </a>

                <a
                  href="https://www.youtube.com/@iamaramai"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
                  data-umami-event="youtube"
                >
                  <Youtube className="h-5 w-5 text-gray-400" />
                  <span className="text-gray-300">Subscribe on YouTube</span>
                </a>

                <a
                  href="https://www.promptmanager.pro/"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
                  data-umami-event="prompt manager"
                >
                  <Globe className="h-5 w-5 text-gray-400" />
                  <span className="text-gray-300">Explore Prompt Manager</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
